import {
  Grid as DreiGrid,
  GridProps as DreiGridProps,
} from '@react-three/drei';

export type GridProps = Partial<
  Pick<
    DreiGridProps,
    | 'args'
    | 'cellSize'
    | 'cellThickness'
    | 'cellColor'
    | 'sectionSize'
    | 'sectionThickness'
    | 'sectionColor'
    | 'fadeDistance'
    | 'followCamera'
    | 'castShadow'
    | 'infiniteGrid'
    | 'renderOrder'
  >
>;

export default function Grid({
  args,
  cellSize = 1,
  cellThickness = 1,
  cellColor = '#7A7A7A',
  sectionSize,
  sectionThickness,
  sectionColor = '#7A7A7A',
  fadeDistance = 35,
  followCamera = false,
  castShadow = false,
  infiniteGrid = true,
  renderOrder = -2,
}: GridProps) {
  return (
    <DreiGrid
      args={args}
      cellSize={cellSize}
      cellThickness={cellThickness}
      cellColor={cellColor}
      sectionSize={sectionSize}
      sectionThickness={sectionThickness}
      sectionColor={sectionColor}
      fadeDistance={fadeDistance}
      followCamera={followCamera}
      castShadow={castShadow}
      infiniteGrid={infiniteGrid}
      renderOrder={renderOrder}
      name="DreiGrid"
    />
  );
}
